import { useDisclosure } from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';

import {
  ChangePasswordInput,
  changePasswordInputSchema,
} from '../schemas/change-password';

import { MfaSettingModals } from './mfa-setting-modal';
import { PasswordChangeCancelModal } from './password-change-cancel-modal';
import { PasswordChangeFormModal } from './password-change-form-modal';

type PasswordChangeModalsProps = {
  isPasswordChangeFormModalOpen: boolean;
  onPasswordChangeFormModalClose: () => void;
};

export const PasswordChangeModals = (props: PasswordChangeModalsProps) => {
  console.info('password-change-modals.tsx_1');

  const { isPasswordChangeFormModalOpen, onPasswordChangeFormModalClose } =
    props;
  const {
    isOpen: isPasswordChangeCancelModalOpen,
    onOpen: onPasswordChangeCancelModalOpen,
    onClose: onPasswordChangeCancelModalClose,
  } = useDisclosure();

  const methods = useForm<ChangePasswordInput>({
    resolver: zodResolver(changePasswordInputSchema),
  });

  const handleCancelConfirm = () => {
    console.info('password-change-modals.tsx_2');

    onPasswordChangeCancelModalClose();
    onPasswordChangeFormModalClose();
    methods.reset();
  };

  const {
    isOpen: isMfaSettingModalOpen,
    onOpen: onMfaSettingModalOpen,
    onClose: onMfaSettingModalClose,
  } = useDisclosure();

  return (
    <>
      <FormProvider {...methods}>
        {!isMfaSettingModalOpen ? (
          <PasswordChangeFormModal
            isPasswordChangeFormModalOpen={isPasswordChangeFormModalOpen}
            onPasswordChangeFormModalClose={onPasswordChangeFormModalClose}
            onPasswordChangeCancelModalOpen={onPasswordChangeCancelModalOpen}
            onMfaSettingModalOpen={onMfaSettingModalOpen}
          />
        ) : (
          <MfaSettingModals
            isOpen={isMfaSettingModalOpen}
            onClose={onMfaSettingModalClose}
            isPasswordChangeFormModalOpen={isPasswordChangeFormModalOpen}
            onPasswordChangeFormModalClose={onPasswordChangeFormModalClose}
            onPasswordChangeCancelModalOpen={onPasswordChangeCancelModalOpen}
          />
        )}
      </FormProvider>
      <PasswordChangeCancelModal
        isPasswordChangeCancelModalOpen={isPasswordChangeCancelModalOpen}
        onPasswordChangeCancelModalClose={onPasswordChangeCancelModalClose}
        handleCancelConfirm={handleCancelConfirm}
      />
    </>
  );
};
